<div class="container">
    <img class="logo" src="../../../../../assets/logos/full-small.svg">
    <div class="content">
        <img class="icon" [src]="'../../../../../assets/artwork/' +  imageName">
        <p class="{{display}}">{{ content }}</p>    
    </div>
</div>